import { render, staticRenderFns } from "./FixTop.vue?vue&type=template&id=33d149e7&"
import script from "./FixTop.vue?vue&type=script&lang=js&"
export * from "./FixTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports